import AuditlogAPI from '@/api/auditlog'

const state = {

};

const mutations = {

};

const actions = {
    write(context, payload) {
        AuditlogAPI.writeEntry(context.rootState.cafe._id, payload.type, payload.payload).then(() => {
            console.log(`[Auditlog] Written entry "${payload.type}"`);
        }).catch(error => {
            console.error(`[Auditlog] ${error}`);
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}